<div class="w100 col gap-16">
    <rr-icon name="trash" class="roundicon"></rr-icon>
    <div class="col w100 gap-8">
        <h3 i18n>Delete your Company</h3>
        <p>Are you sure you want to delete your company?</p>
        <div class="checkbox">
            <rr-checkbox (click)="membersDelete = !membersDelete"></rr-checkbox>
            <div class="checkbox-text">Delete users who do not have their own license</div>
        </div>
        <p class="tiny color-strong">Users without their own license will be deleted when the company is removed.<br>
        If this option is not selected, they will become standalone users and receive a default license.</p>
    </div>
    <div class="btn-row w100">
        <rr-btn type="Secondary" size="Medium" (btnclick)="close()">Cancel</rr-btn>
        <rr-btn type="Primary" size="Medium" (btnclick)="deleteCompany()">Delete</rr-btn>
    </div>
</div>